import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b014fca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Advertising Requirements\n          ")
], -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Do you want the recruitment team to advertise the role? *")
], -1));
const _hoisted_6 = { class: "mt-4 space-y-4" };
const _hoisted_7 = { class: "flex items-start" };
const _hoisted_8 = { class: "h-5 flex items-center" };
const _hoisted_9 = ["disabled", "checked"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitmentTeam",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1));
const _hoisted_11 = { class: "flex items-start" };
const _hoisted_12 = { class: "h-5 flex items-center" };
const _hoisted_13 = ["disabled", "checked"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitmentTeam",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1));
const _hoisted_15 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-gray-500" }, "\n              * If you would like to review the full recruitment policy please\n              click here\n            ", -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, "\n              * All vacancies should be advertised in line with European Social\n              Agreement and approvers are instructed to challenge this decision.\n            ", -1));
const _hoisted_18 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Why have you chosen not to advertise? *")
], -1));
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = { class: "mt-4 space-y-4" };
const _hoisted_22 = { class: "flex items-start" };
const _hoisted_23 = { class: "h-5 flex items-center" };
const _hoisted_24 = ["checked", "disabled"];
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "chosen_not",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Already Recruited")
], -1));
const _hoisted_26 = { class: "flex items-start" };
const _hoisted_27 = { class: "h-5 flex items-center" };
const _hoisted_28 = ["disabled", "checked"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "internal_promotion",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Internal Promotion")
], -1));
const _hoisted_30 = { class: "flex items-start" };
const _hoisted_31 = { class: "h-5 flex items-center" };
const _hoisted_32 = ["disabled", "checked"];
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "chosen_not",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Other")
], -1));
const _hoisted_34 = { key: 0 };
const _hoisted_35 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_36 = { class: "col-span-6" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "advertise",
    class: "block text-sm font-medium text-gray-70"
}, "Which wording would you like to use to advertise the salary?\n                  *", -1));
const _hoisted_38 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_39 = ["value", "disabled"];
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    selected: "",
    disabled: ""
}, "Please select", -1));
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Don't Advertise Salary or Band" }, "\n                    Don't Advertise Salary or Band\n                  ", -1));
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "On offer is a salary of XXXX, dependent upon skills and experience" }, "\n                    On offer is a salary of XXXX, dependent upon skills and\n                    experience\n                  ", -1));
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "On offer is a salary banding of XXXX-XXXX, dependent upon skills and experience" }, "\n                    On offer is a salary banding of XXXX-XXXX, dependent upon\n                    skills and experience\n                  ", -1));
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "On offer is a salary of XXXX per hour" }, "\n                    On offer is a salary of XXXX per hour\n                  ", -1));
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "On offer is a salary of XXXX per annum" }, "\n                    On offer is a salary of XXXX per annum\n                  ", -1));
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Use my own specific wording (please specify)" }, "\n                    Use my own specific wording (please specify)\n                  ", -1));
const _hoisted_47 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "advertiseOther" }, "Please specify the wording you would like to use *", -1));
const _hoisted_49 = ["value", "disabled"];
const _hoisted_50 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_51 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  What channels would you like to use to advertise the role? *\n                ")
], -1));
const _hoisted_53 = { class: "mt-4 space-y-4" };
const _hoisted_54 = { class: "flex items-start" };
const _hoisted_55 = { class: "h-5 flex items-center" };
const _hoisted_56 = ["disabled", "checked"];
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Equans Jobs Internal (*mandatory for all advertised roles\n                      as per European Social Agreement) *FREE")
], -1));
const _hoisted_58 = { class: "flex items-start" };
const _hoisted_59 = { class: "h-5 flex items-center" };
const _hoisted_60 = ["disabled", "checked"];
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Equans Jobs External *FREE")
], -1));
const _hoisted_62 = { class: "flex items-start" };
const _hoisted_63 = { class: "h-5 flex items-center" };
const _hoisted_64 = ["disabled", "checked"];
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Approved External Agency *COSTS WILL BE INCURRED")
], -1));
const _hoisted_66 = { class: "flex items-start" };
const _hoisted_67 = { class: "h-5 flex items-center" };
const _hoisted_68 = ["disabled", "checked"];
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Indeed and Universal Jobs *FREE")
], -1));
const _hoisted_70 = { class: "flex items-start" };
const _hoisted_71 = { class: "h-5 flex items-center" };
const _hoisted_72 = ["disabled", "checked"];
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "LinkedIn *COSTS WILL BE INCURRED")
], -1));
const _hoisted_74 = { class: "flex items-start" };
const _hoisted_75 = { class: "h-5 flex items-center" };
const _hoisted_76 = ["disabled", "checked"];
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Other Websites *COSTS WILL BE INCURRED")
], -1));
const _hoisted_78 = { class: "flex items-start" };
const _hoisted_79 = { class: "h-5 flex items-center" };
const _hoisted_80 = ["disabled", "checked"];
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "channels",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Other (please specify)")
], -1));
const _hoisted_82 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_83 = { key: 1 };
const _hoisted_84 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_85 = ["value", "disabled"];
const _hoisted_86 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "\n                  Do you want the recruitment team to shortlist the\n                  applications? *\n                ")
], -1));
const _hoisted_88 = { class: "mt-4 space-y-4" };
const _hoisted_89 = { class: "flex items-start" };
const _hoisted_90 = { class: "h-5 flex items-center" };
const _hoisted_91 = ["disabled", "checked"];
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitmentShortlist",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1));
const _hoisted_93 = { class: "flex items-start" };
const _hoisted_94 = { class: "h-5 flex items-center" };
const _hoisted_95 = ["disabled", "checked"];
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "recruitment-shortlist-no",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1));
const _hoisted_97 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_98 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_99 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("input", {
                                    id: "radio-button-recruitment-team-yes",
                                    value: "Yes",
                                    name: "recruitmentTeam",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        }]),
                                    disabled: _ctx.showApprovalSteps,
                                    checked: _ctx.formData.recruitmentTeam === 'Yes',
                                    onChange: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                    onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.recruitmentTeam.$touch()))
                                }, null, 42, _hoisted_9)
                            ]),
                            _createTextVNode(),
                            _hoisted_10
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("input", {
                                    id: "radio-button-recruitment-team-no",
                                    value: "No",
                                    name: "recruitmentTeam",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        }]),
                                    disabled: _ctx.showApprovalSteps,
                                    checked: _ctx.formData.recruitmentTeam === 'No',
                                    onChange: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.recruitmentTeam.$touch()))
                                }, null, 42, _hoisted_13)
                            ]),
                            _createTextVNode(),
                            _hoisted_14
                        ]),
                        _createTextVNode(),
                        (_ctx.v$.formData.recruitmentTeam.$errors.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "\n              * " + _toDisplayString(_ctx.v$.formData.recruitmentTeam.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _hoisted_16,
                        _createTextVNode(),
                        _hoisted_17
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_19,
                            _createTextVNode(),
                            (_ctx.v$.formData.chosen_not.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n                * " + _toDisplayString(_ctx.v$.formData.chosen_not.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("input", {
                                            id: "radio-button-already-recruited",
                                            name: "chosen_not",
                                            type: "radio",
                                            value: "already_recruited",
                                            class: _normalizeClass([{
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }, "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"]),
                                            checked: _ctx.formData.chosen_not === 'already_recruited',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.chosen_not.$touch()))
                                        }, null, 42, _hoisted_24)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_25
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("input", {
                                            id: "radio-button-internal-promotion",
                                            name: "chosen_not",
                                            type: "radio",
                                            value: "internal_promotion",
                                            class: _normalizeClass([{
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }, "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.chosen_not === 'internal_promotion',
                                            onChange: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.chosen_not.$touch()))
                                        }, null, 42, _hoisted_28)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_29
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("input", {
                                            id: "radio-button-other",
                                            name: "chosen_not",
                                            type: "radio",
                                            value: "other",
                                            class: _normalizeClass([{
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }, "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.chosen_not === 'other',
                                            onChange: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.chosen_not.$touch()))
                                        }, null, 42, _hoisted_32)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_33
                                ])
                            ])
                        ])
                    ], 512), [
                        [_vShow, _ctx.formData.recruitmentTeam === 'No']
                    ]),
                    _createTextVNode(),
                    (_ctx.formData.recruitmentTeam === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _hoisted_37,
                                    _createTextVNode(),
                                    (_ctx.v$.formData.advertise.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, "\n                  * " + _toDisplayString(_ctx.v$.formData.advertise.$errors[0].$message), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "adrequirements",
                                        name: "advertise",
                                        autocomplete: "advertise",
                                        value: _ctx.formData.advertise,
                                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                'error-border': _ctx.v$.formData.advertise.$error,
                                                'border-red-500': _ctx.v$.formData.advertise.$error,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        onChange: _cache[10] || (_cache[10] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.advertise.$touch()))
                                    }, [
                                        _hoisted_40,
                                        _createTextVNode(),
                                        _hoisted_41,
                                        _createTextVNode(),
                                        _hoisted_42,
                                        _createTextVNode(),
                                        _hoisted_43,
                                        _createTextVNode(),
                                        _hoisted_44,
                                        _createTextVNode(),
                                        _hoisted_45,
                                        _createTextVNode(),
                                        _hoisted_46
                                    ], 42, _hoisted_39)
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.formData.advertise ===
                                'Use my own specific wording (please specify)')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        type: "text",
                                        name: "advertiseOther",
                                        value: _ctx.formData.advertiseOther,
                                        class: _normalizeClass(["mt-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                'error-border': _ctx.v$.formData.advertiseOther.$error,
                                                'border-red-500': _ctx.v$.formData.advertiseOther.$error,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        onInput: _cache[12] || (_cache[12] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                        onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.advertiseOther.$touch()))
                                    }, null, 42, _hoisted_49),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.advertiseOther.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, "\n                * " + _toDisplayString(_ctx.v$.formData.advertiseOther.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-internal",
                                                value: "channels-internal",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-internal'),
                                                onChange: _cache[14] || (_cache[14] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_56)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_57
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-external",
                                                value: "channels-external",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-external'),
                                                onChange: _cache[16] || (_cache[16] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_60)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_61
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_62, [
                                        _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-agency",
                                                value: "channels-agency",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-agency'),
                                                onChange: _cache[18] || (_cache[18] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[19] || (_cache[19] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_64)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_65
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-indeed",
                                                value: "channels-indeed",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-indeed'),
                                                onChange: _cache[20] || (_cache[20] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[21] || (_cache[21] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_68)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_69
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_70, [
                                        _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-linkedin",
                                                value: "channels-linkedin",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-linkedin'),
                                                onChange: _cache[22] || (_cache[22] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[23] || (_cache[23] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_72)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_73
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-website",
                                                value: "channels-website",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-website'),
                                                onChange: _cache[24] || (_cache[24] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[25] || (_cache[25] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_76)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_77
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("input", {
                                                id: "checkbox-button-channels-other",
                                                value: "channels-other",
                                                name: "channels",
                                                type: "checkbox",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.channels.includes('channels-other'),
                                                onChange: _cache[26] || (_cache[26] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleCheckboxChange && _ctx.handleCheckboxChange(...args))),
                                                onBlur: _cache[27] || (_cache[27] = ($event) => (_ctx.v$.formData.channels.$touch()))
                                            }, null, 42, _hoisted_80)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_81
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.channels.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.v$.formData.channels.$errors[0].$message), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    (_ctx.formData.channels.includes('channels-other'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                            (_ctx.v$.formData.channelsOther.$errors.length)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_84, "\n                    * " + _toDisplayString(_ctx.v$.formData.channelsOther.$errors[0].$message), 1))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(),
                                            _createElementVNode("input", {
                                                type: "text",
                                                name: "channelsOther",
                                                value: _ctx.formData.channelsOther,
                                                class: _normalizeClass(["mt-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                onInput: _cache[28] || (_cache[28] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                                onBlur: _cache[29] || (_cache[29] = ($event) => (_ctx.v$.formData.channelsOther.$touch()))
                                            }, null, 42, _hoisted_85)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_86, [
                                _hoisted_87,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("div", _hoisted_90, [
                                            _createElementVNode("input", {
                                                id: "radio-button-recruitment-shortlist-yes",
                                                value: "Yes",
                                                name: "recruitmentShortlist",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.recruitmentShortlist === 'Yes',
                                                onChange: _cache[30] || (_cache[30] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                            }, null, 42, _hoisted_91)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_92
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_93, [
                                        _createElementVNode("div", _hoisted_94, [
                                            _createElementVNode("input", {
                                                id: "radio-button-recruitment-shortlist-no",
                                                value: "No",
                                                name: "recruitmentShortlist",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.recruitmentShortlist === 'No',
                                                onChange: _cache[31] || (_cache[31] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                            }, null, 42, _hoisted_95)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_96
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.recruitmentShortlist.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_97, "\n                  * " + _toDisplayString(_ctx.v$.formData.recruitmentShortlist.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[32] || (_cache[32] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[33] || (_cache[33] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_99)
            ]))
            : _createCommentVNode("", true)
    ]));
}
